<section
  class="filters-section"
  [class.filters-section--divider]="showDivider()">
  @if (titleKey() && icon()) {
    <pwj-filters-section-heading [titleKey]="titleKey()!" [icon]="icon()!" />
  }
  <ng-content />
</section>
